import { css } from '@/styled-system/css';

export const dropdownContentStyles = css.raw({
  'display': 'flex',
  'borderRadius': 'obj.soft',
  'flexDirection': 'column',
  'backgroundColor': 'Dropdown.Content.bg',
  'boxShadow': 'md',
  'position': 'relative',
  'overflow': 'hidden',

  '& > .c11n_dropdown__header:first-child > .c11n_dropdown__heading': {
    borderStartStartRadius: 'obj.soft',
    borderStartEndRadius: 'obj.soft',
  },
});

export const dropdownContentPositionerStyles = css.raw({
  zIndex: 'dropdown',
});
